export const AGE = [
	{ id: 0, name: "0 year" },
	{ id: 1, name: "1 year" },
	{ id: 2, name: "2 years" },
	{ id: 3, name: "3 years" },
	{ id: 4, name: "4 years" },
	{ id: 5, name: "5 years" },
	{ id: 6, name: "6 years" },
	{ id: 7, name: "7 years" },
	{ id: 8, name: "8 years" },
	{ id: 9, name: "9 years" },
	{ id: 10, name: "10+ years" },
];

export const AGE_UNIT = "years";

export const CONDITIONS = [
	{ id: "pre owned", name: "Pre Owned" },
	{ id: "new", name: "New / Unused" },
	{ id: "seller_refurbished", name: "Refurbished" },
	{ id: "defected", name: "Defected" },
	{ id: "for_parts", name: "For Parts" },
	{ id: "mix", name: "Mix" },
];

export const COND_CONDITIONS = [
	{ id: "pre owned", name: "Pre Owned" },
	{ id: "new", name: "New / Unused" },
	{ id: "seller_refurbished", name: "Refurbished" },
	{ id: "defected", name: "Defected" },
	{ id: "for_parts", name: "For Parts" },
	{ id: "mix", name: "Mix" },
];

export const ShippingTypes = [
	// { id: "fedex", name: "FedEx" },
	{ id: "free_shipping", name: "Free Shipping" },
	{ id: "local_pickup_only", name: "Local Pickup Only" },
	// {
	// 	id: "fedex_or_local_pickup",
	// 	name: "Both (FedEx | Local Pickup)",
	// },
];

export const DEALSTATUS = [
	{ id: "Pending", name: "Pending", class: "pending" },
	{ id: "Approved", name: "Approved", class: "approved" },
	{ id: "Incomplete", name: "Incomplete", class: "incomplete" },
	{ id: "Rejected", name: "Rejected", class: "rejected" },
	{ id: "Disabled", name: "Disabled", class: "disabled" },
	{ id: "Contract", name: "Contract", class: "pending" },
	{ id: "Active", name: "Active" },
	{ id: "OutOfStock", name: "Out of Stock" },
	{ id: "Inactive", name: "In-Active" },
	{ id: "", name: "All", class: "disabled" },
];
export const INCOTERMS = [
	{ id: "EXW", name: "EXW - Ex Works (Place)" },
	{ id: "DDP", name: "DDP - Delivered Duty Paid (Place)" },
	{ id: "DAP", name: "DAP - Delivered at Place (Place)" },
	{ id: "Flexible", name: "Flexible - Open to Discuss" },

	{ id: "CIF", name: "CIF - Cost Insurance & Freight (Port)" },

	{ id: "FOB", name: "FOB - Free on Board (Port)" },
	{ id: "FCA", name: "FCA - Free Carrier (Place)" },
	{ id: "FAS", name: "FAS - Free Alongside Ship (Port)" },

	{ id: "CFR", name: "CFR - Cost and Freight (Port)" },

	{ id: "CPT", name: "CPT - Carriage Paid To (Place)" },
	{ id: "CIP", name: "CIP - Carriage & Insurance Paid to (Place)" },
	{ id: "DPU", name: "DPU - Delivered at Place Unloaded (Place)" },
];
export const COLORS = [
	{ id: "silver", name: "Silver" },
	{ id: "black", name: "Black" },
	{ id: "white", name: "White" },
	{ id: "transparent", name: "Transparent" },
];

export const STATUS = [
	{ id: "Pending", name: "Pending" },
	{ id: "Approved", name: "Approved" },
	{ id: "Incomplete", name: "Incomplete" },
	{ id: "Rejected", name: "Rejected" },
	{ id: "Disabled", name: "Disabled" },

	// {"id": "Delete", "name": "Delete"},
];

export const SUPER_STATUS = [
	{ id: "Pending", name: "Pending" },
	{ id: "Approved", name: "Approved" },
	{ id: "Incomplete", name: "Incomplete" },
	{ id: "Active", name: "Active" },
	{ id: "OutOfStock", name: "Out of Stock" },
	{ id: "Disabled", name: "Disabled" },
	{ id: "Rejected", name: "Rejected" },
	{ id: "Private", name: "Private" },

	// {"id": "Delete", "name": "Delete"},
];

export const ADMIN_STATUS = [
	{ id: "Approved", name: "Approved" },
	{ id: "Pending", name: "Pending" },
	{ id: "Active", name: "Active" },
	{ id: "Rejected", name: "Rejected" },
	{ id: "Private", name: "Private" },
];

export const Cell_TYPE = [
	{ id: "Heterojunction", name: "Heterojunction" },
	{ id: "Mono", name: "Mono" },
	{ id: "Bifacial", name: "Bifacial" },
	{ id: "Poly", name: "Poly" },
	{ id: "TOPCon", name: "TOPCon" },
	{ id: "Q Antum", name: "Q Antum" },
	{ id: "Thin Film", name: "Thin Film" },
	{ id: "N-Type", name: "N-Type" },
	{ id: "PERC", name: "PERC" },
	{ id: "Other", name: "Other" },
];

export const CONNECTOR_TYPE = [
	{ id: "MC4 Compatible", name: "MC4 Compatible" },
	{ id: "MC4/Staubli", name: "MC4/Staubli" },
	{ id: "EVO2", name: "EVO2" },
	{ id: "QC4", name: "QC4" },
	{ id: "T4", name: "T4" },
	{ id: "T6", name: "T6" },
	{ id: "other", name: "Other" },
];

export const DAYS_OF_INSPECTION = [
	{ id: "3 days", name: "3 days" },
	{ id: "5 days", name: "5 days" },
	{ id: "10 days", name: "10 days" },
	{ id: "15 days", name: "15 days" },
	{ id: "30 days", name: "30 days" },
];

export const WIND_LOAD = [
	{ id: "2400 Pa", name: "2400 Pa" },
	{ id: "3000 Pa", name: "3000 Pa" },
	{ id: "3600 Pa", name: "3600 Pa" },
	{ id: "4000 Pa", name: "4000 Pa" },
	{ id: "5400 Pa", name: "5400 Pa" },
	{ id: "6000 Pa", name: "6000 Pa" },
	{ id: "6200 Pa", name: "6200 Pa" },
];
export const SNOW_LOAD = [
	{ id: "3000 Pa", name: "3000 Pa" },
	{ id: "5400 Pa", name: "5400 Pa" },
	{ id: "6000 Pa", name: "6000 Pa" },
	{ id: "7000 Pa", name: "7000 Pa" },
	{ id: "8100 Pa", name: "8100 Pa" },
];
export const WEIGHT_UNIT = ["lb", "kg"];
export const LENGTH_UNIT = ["in", "cm"];

export const COMPANY_TIER = [
	{ id: "Tier 1", name: "Tier 1" },
	{ id: "Tier 2", name: "Tier 2" },
	{ id: "Tier 3", name: "Tier 3" },
];

export const INVERTER_TYPE = [
	{ id: "Single Phase", name: "Single Phase" },
	{ id: "Three Phase", name: "Three Phase" },
];

export const GRID_VOLTAGE = [
	{ id: "120 V", name: "120 V" },
	{ id: "220 V", name: "220 V" },
	{ id: "240 V", name: "240 V" },
	{ id: "120/208 V", name: "120/208 V" },
	{ id: "277/480 V", name: "277/480 V" },
	{ id: "600 V", name: "600 V" },
	{ id: "800 V", name: "800 V" },
];

export const Service_Type = [
	{ id: "Logistics", name: "Logistics" },
	{ id: "Warehousing", name: "Warehousing" },
	{ id: "Special Handling", name: "Special Handling" },
	{ id: "Sales Tax", name: "Sales Tax" },
	{ id: "Processing Fee", name: "Processing Fee" },
	{ id: "Custom", name: "Custom" },
];
export const MOQUNITS = [
	{ id: "panels", name: "Panels" },
	{ id: "pallets", name: "Pallets" },
	{ id: "containers", name: "Containers" },
	{ id: "MW", name: "MW" },
];

export const brokerListingButtons = {
	moqUnit: [
		{
			param: "/mu_pallets",
			label: "Pallets",
			imgUrl: "assets/images/revamp/pallet-icon.svg",
		},
		{
			param: "/mu_containers",
			label: "Containers",
			imgUrl: "assets/images/revamp/container-icon.svg",
		},
		{
			param: "/mu_mw",
			label: "MW+",
			icon: "fas fa-bolt fa-xl",
		},
	],
	category: [
		{
			param: "/ca_solar-panels",
			label: "Panels",
			imgUrl: "assets/images/revamp/solar-panel-icon.svg",
		},
		{
			param: "/ca_solar-inverters",
			label: "Inverters",
			imgUrl: "assets/images/revamp/solar-inverter.svg",
		},
		{
			param: "/ca_solar-batteries",
			label: "Batteries",
			imgUrl: "assets/images/revamp/solar-batteries.svg",
		},
	],
	wattage: [
		{
			param: "/pw_300%2c395",
			label: "300s",
		},
		{
			param: "/pw_400%2c495",
			label: "400s",
		},
		{
			param: "/pw_500%2c595",
			label: "500s",
		},
		{
			param: "/pw_600",
			label: "600+",
		},
	],
};

export const traderCatHeading = [
	{
		name: "Solar Panels",
		heading: "Solar Power Panels",
	},
	{
		name: "Solar Inverters",
		heading: "Solar Inverter Seller in United States",
	},
	{
		name: "Solar Batteries",
		heading: "Solar Batteries, Backup and Battery Components",
	},
	{
		name: "Racking & Mounts",
		heading: "Solar Panel Racking & Mounts",
	},
	{
		name: "PV Cables",
		heading: "PV Cables for Solar Panel",
	},
	{
		name: "Complete PV Systems",
		heading: "Complete PV System For Solar Panel Systems",
	},
	{
		name: "PV Connectors",
		heading: "Solar PV Cables & Connectors",
	},
	{
		name: "Components Parts",
		heading: "Solar Panel BOS Components",
	},
	{
		name: "DIY Kits & Equipment",
		heading: "Solar Panel Kits for Home & Commercial",
	},
	{
		name: "Solar Lights",
		heading: "Solar Light Products",
	},
	{
		name: "EV Chargers",
		heading: "EV Chargers for both Residential & Commercial",
	},
	{
		name: "Generator",
		heading: "Generator",
	},
];

export const DEAL_RANKING = [
	{ id: 1, name: "1" },
	{ id: 2, name: "2" },
	{ id: 3, name: "3" },
	{ id: 4, name: "4" },
	{ id: 5, name: "5" },
	{ id: 6, name: "6" },
	{ id: 7, name: "7" },
	{ id: 8, name: "8" },
	{ id: 9, name: "9" },
	{ id: 10, name: "10" },
];
// secrtor
export const SECTORS = [
	{ id: "residential", name: "Residential" },
	{ id: "commercial", name: "Commercial" },
	{ id: "utility_scale", name: "Utility Scale" },
];
// secrtor
export const SECTORS_MARKETPLACE = [
	{ id: 1, name: "Residential" },
	{ id: 2, name: "Commercial" },
	{ id: 3, name: "Utility Scale" },
];
export const seoTitles = {
	"300-watt-solar-panels": {
		heading: "Shop 300W Solar Panels with Negotiable Prices",
	},
	"400-watt-solar-panels": {
		heading: "Shop 400W Solar Panels with Negotiable Prices",
	},
	"500-watt-solar-panels": {
		heading: "Shop 500W Solar Panels with Negotiable Prices",
	},
	"600-watt-solar-panels": {
		heading: "Shop 600W Solar Panels with Negotiable Prices",
	},
};

export const seoMeta = {
	"300-watt-solar-panels": {
		title: "Shop 300W Solar Panels – Negotiable Prices | Affordable & Compact Solar Power",
		description:
			"Explore top-rated 300 watt solar panels with negotiable prices for homes and businesses. Ideal for compact solar needs, Sunhub offers reliable and cost-effective 300W solar panels.",
	},
	"400-watt-solar-panels": {
		title: "Shop 400W Solar Panels – Negotiable Prices | Reliable Power for Home & Business",
		description:
			"Find the best 400 watt solar panels with negotiable prices for your energy needs. Perfect for residential and commercial setups, our 400W solar panels deliver reliable performance.",
	},
	"500-watt-solar-panels": {
		title: "Shop 500W Solar Panels – Negotiable Prices - High Capacity Solar Power",
		description:
			"Power your system with high-performance 500 watt solar panels with negotiable prices. Great for large-scale energy needs, our 500W solar panels offer superior efficiency and output.",
	},
	"600-watt-solar-panels": {
		title: "Shop 600W Solar Panels – Negotiable Prices | Industrial-Grade Solar Power Solutions",
		description:
			"Shop top-tier 600 watt solar panels with negotiable prices designed for high energy output. Best suited for commercial or industrial use, our 600W solar panels are built for durability and efficiency.",
	},
};
